import userDepartment from "@/http/requests/userDepartment"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      userDepartment.fetch().then(response => {
        commit('SET_USER_DEPARTMENTS', response.data.data.userDepartments)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      userDepartment.add(data).then(response => {
        commit('ADD_USER_DEPARTMENT', response.data.data.createUserDepartment)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      userDepartment.update(data).then(response => {
        commit('UPDATE_USER_DEPARTMENT', response.data.data.updateUserDepartment)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  delete({ commit }, userDepartmentId) {
    return new Promise((resolve, reject) => {
      userDepartment.delete(userDepartmentId).then(response => {
        commit('DELETE_USER_DEPARTMENT', userDepartmentId)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  addSchedule({ commit }, data) {
    return new Promise((resolve, reject) => {
      userDepartment.addSchedule(data).then(response => {
        commit('ADD_DEPARTMENT_SCHEDULE', response.data.data.createUserDepartmentSchedule)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
  deleteSchedule({ commit }, userDepartmentsId) {
    return new Promise((resolve, reject) => {
      userDepartment.deleteSchedule(userDepartmentsId).then(response => {
        commit('DELETE_DEPARTMENT_SCHEDULE', userDepartmentsId)
        resolve(response)
      }).catch((error) => { reject(error) })
    })
  },
}
